import { ContextRoleScopeComponentDTO } from './context-role-scope-component-dto';
import { ResponseDTO } from './response-dto';

export interface ReadContextRoleScopePickerResponseDTO extends ResponseDTO {
    components?: ContextRoleScopeComponentDTO[];
}
